import { Directive, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { FacilityService } from './facility.service'

@Directive({
  selector: '[appFacilitySelect]',
})
export class FacilitySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderSelectComponent)
  private facilityService = inject(FacilityService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'name'
    this.select.placeholder = 'context.facility'
    this.select.dataSource = this.facilityService
    this.select.sorts = [new Sort('id', 'asc')]
  }
}
